import { FoodsSelect, FormUnit } from "@foodpilot/foods";
import {
    deserializeOptionsFromProperty,
    serializeOptionsFromProperty,
} from "src/context/Property/PropertyValueSerializer";
import { useState } from "react";
import { CommonPropertyProps } from "./_common";
import { ScoreService } from "src/context/EntityBasedScore/ScoreService";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { Stack, useTheme } from "@mui/material";

type SelectProps = CommonPropertyProps;
export const Select = (props: SelectProps) => {
    const theme = useTheme();
    const { selectedScore } = useActionsContext();
    const { property, updatePropertyValue, isLocked = false, shouldShowSubscore = false, comparisonProperty } = props;
    const options = property.property.dataList?.options;

    const values = deserializeOptionsFromProperty(property);
    const [selectedValue, setSelectedValue] = useState(values.value);

    const comparedTo = comparisonProperty?.score?.value ?? null;
    const currentScore = property.score?.value ?? null;
    const _scoreDiff = ScoreService.substractScore(comparedTo, currentScore);
    const scoreDiff = ScoreService.normalizeScore(_scoreDiff, selectedScore.precision).value;
    const score = shouldShowSubscore && scoreDiff !== 0 ? scoreDiff : null;
    return (
        <Stack flexDirection={"row"} alignItems={"center"} gap={theme.spacing(2)}>
            <FoodsSelect
                selectedOption={selectedValue ?? null}
                options={options ?? []}
                onChange={(newValue) => {
                    if (newValue !== null) setSelectedValue(newValue);

                    const serializedValue = serializeOptionsFromProperty(newValue ?? undefined);
                    updatePropertyValue({
                        serializedString: serializedValue.value,
                        dataListOptionIds: serializedValue.dataListOptionIds,
                        calculationType: "action",
                    });
                }}
                getId={(option) => option.id}
                getName={(option) => option.label}
                unit={property.unit}
                disabled={isLocked}
                textOptions={{
                    placeholder: "",
                    searchPlaceholder: "",
                    emptyOptionsText: "",
                    defaultValueText: undefined,
                    noResult: "",
                }}
            />
            {score !== null && (
                <FormUnit
                    value={score}
                    unit={selectedScore.unit}
                    comparison={{
                        value: currentScore,
                        toCompareTo: comparedTo,
                        improvement: selectedScore.improvement,
                    }}
                />
            )}
        </Stack>
    );
};
